/* ==========================================================================
   ZONEX PHARMA — Reviews layout

   Deliberately conservative: this script never moves, hides or deletes any
   element belonging to the review app. Doing that is what broke the widget
   before — the app rebuilds its widget after loading, and anything removed
   mid-flight took the reviews with it.

   Instead we move OUR OWN summary card next to the app's widget and let CSS
   put the two side by side. Our element, our risk.
   ========================================================================== */

(function () {
  'use strict';

  var WIDGET_SEL = '.jdgm-rev-widg, .jdgm-widget.jdgm-review-widget, .jdgm-widget';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function pair() {
    var card = $('[data-zxrv-card]');
    if (!card) return;

    var widget = $(WIDGET_SEL);
    if (!widget) return;

    // Outermost widget node, so we sit beside the whole thing
    var outer = widget;
    var parent = outer.parentElement;
    while (parent && parent.children.length === 1 && !parent.classList.contains('shopify-section')) {
      outer = parent;
      parent = outer.parentElement;
    }
    if (!parent) return;

    // Already paired and still in place
    if (card.previousElementSibling === null && card.parentElement === parent) return;
    if (card.parentElement === parent && card.nextElementSibling === outer) return;

    try {
      parent.insertBefore(card, outer);
      parent.classList.add('zxrv-paired');

      var host = parent.closest('.shopify-section') || parent;
      host.classList.add('zxrv-host');

      // Our section's placeholder column is no longer needed
      var slot = $('[data-zxrv-slot]');
      if (slot) slot.hidden = true;

      // The app supplies the working button, so drop ours
      var fallback = $('[data-zxrv-fallback]');
      if (fallback) fallback.hidden = true;
    } catch (err) {
      /* leave everything where it is — the page still works */
    }
  }

  function boot() {
    pair();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The widget arrives after page load and may be rebuilt once
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    boot();
    if (tries > 20) clearInterval(timer);
  }, 600);

  document.addEventListener('shopify:section:load', boot);
})();
